import React from "react";
import { useNavigate } from 'react-router-dom';

import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { iconSize, ideaColor } from "../../App/GridRenderers";




const IdeaBoardIcon = ({ mt = 0 }) => {
    const navigate = useNavigate();
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="Suggestion Board"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faLightbulb}
                        color={ideaColor}
                        size={iconSize}
                        onClick={() => {
                            navigate("/ideaboard")
                        }}
                    />
                </Tooltip>

            </Stack>
        </div >
    );
};

export default IdeaBoardIcon;